module.exports = __webpack_public_path__ + "img/couple2.cbd8cd9e.jpg";